import { render, staticRenderFns } from "./SupplierStockTemplatesComponent.vue?vue&type=template&id=5e58c445&"
import script from "./SupplierStockTemplatesComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockTemplatesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports